<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span> <span>đã</span>
    <span class="highlight-action"> {{ action }} </span>
    <span> công việc </span>
    <span class="event ">"{{ taskTitle }}"</span>
  </div>
</template>

<script>
import constants from "../../constants";

export default {
  name: "notification-item-cv",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      taskTitle: null,
      dataJson: null,
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      let action;
      let fromActor = this.dataJson.actor;
      switch (this.vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_PHEDUYET:
          action = "phê duyệt";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_GIAOVIEC:
          action = "giao";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_DANGKY:
          action = "đăng ký";
          fromActor = fromActor || this.dataJson.receiver;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TUCHOI:
          action = "từ chối đăng ký";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TAMDUNG:
          action = "tạm dừng";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_HUY:
          action = "hủy";
          fromActor = fromActor || this.dataJson.receiver;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CHANGE_DEADLINE:
          action = "gia hạn";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_PHEDUYET_HOANTHANH:
          action = "đánh giá công việc";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_TUCHOI_HOANTHANH:
          action = "từ chối duyệt kết quả";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_HOANTHANH:
          action = "cập nhật hoàn thành";
          fromActor = fromActor || this.dataJson.receiver;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.CV_CAPNHAT_TIENDO:
          action = "cập nhật tiến độ";
          fromActor = fromActor || this.dataJson.receiver;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.TK_TASK.COMMENT:
          action = "bình luận";
          break;
        default:
          break;
      }
      this.fromActorFullName = fromActor ? fromActor.fullName : "-";
      this.action = action;
      this.taskTitle = this.dataJson.tkTask.taskTitle;
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-cv.vue